export const Regexp = {
    mobile: /^0{0,1}(1[0-9][0-9])[0-9]{8}$/,
    qq: /^[1-9][0-9]{4,14}$/,
    num: /^(\d)*$/,
    phone_number: /(^0\d{2,4}-\d{5,10})|(^\d{5,10})|(^0{0,1}(1[0-9][0-9])[0-9]{8})$/

};


const TYPE_TRY_OUT = 1; //试用
const TYPE_FORMAL = 2;//正式
const TYPE_RENEW = 3;//续费
const TYPE_FORMAL_AND_RENEW = 4;//新单和续单
const TYPE_APPLY = 5;//申请
const TYPE_RENEW_BEFORE = 6;//提前续费
const TYPE_RENEW_TIMELY = 7;//准时续费
const TYPE_RENEW_AFTER = 8;//延迟续费

const PRODUCT_LINE = 1;//产品线
const FINANCE_LINE = 2;//财务线
const CONTRACT_LINE = 3;//合同线
const FILL_INVOICE = 4;//补充发票
const ADD_PAY = 5;//录入回款
const UPDATE_PAY = 6;//更新回款
const EMPTY_PAY = 7;//清空回款
const DELETE_PAY = 8;//删除回款

const TYPE_CREATE = 1; //新增
const TYPE_CLOSE = 2;//关闭
const TYPE_REVISE = 3;//修订
const TYPE_FILL = 4;//补充


const NEED_RETURN = 0; //需要回访
const NOT_NEED_RETURN = 1;//不需要回访

const TYPE_NO_CHECKED = 2;//待审核
const TYPE_CHECKED = 1;//审核通过
const TYPE_CHECKED_FAIL = 0;//审核未通过
const TYPE_CHECKED_INIT = 3;//审核初始化
const TYPE_CHECKED_UPLOAD = 4;//审核通过未上传

const ZUJUAN_PRODUCT_CODE = 1;//组卷
const XWT_PRODUCT_CODE = 2;//校网通包年版
const XWT_POINT_PRODUCT_CODE = 20;//校网通额度版
const WORK_PRODUCT_CODE = 3;//作业系统
const XB_PRODUCT_CODE = 4;//校本资源库
const XB3_PRODUCT_CODE = 5;//校本3.0
const ZUJUANCOR_PRODUCT_CODE = 6;//组卷合作机构
const BEIKE_PRODUCT_CODE = 7;//备课系统
const MICRO_CLASS_CODE = 8;//微课堂
const DIGITIZEDCAMPUS_PRODUCT_CODE = 11;//数字化校园
const OFFICIAL_WEBSITE_PRODUCT_CODE = 12;//官网设置
const XWT_COIN_PRODUCT_CODE = 13;//校网通学币版
const PAIKE_PRODUCT_CODE = 14;//排课
const PAPER_INSPERCTION_PRODUCT_CODE = 15;//阅卷
const REVISE_NOTICE = "修订成功，需领导审批通过后才可生效";
const PAIKE_NEW_PRODUCT_CODE = 105;//排课（新）
const DIVISION_PRODUCT_CODE = 103;//分班
const VR_PRODUCT_CODE = 106;//VR实验课


const REASON_CONTRACT_AMOUNT_ERR = 1; // 合同金额错误
const REASON_CONTRACT_TIME_ERR = 2; // 合同时间错误
const REASON_RESULT_AMOUNT_ERR = 3; // 业绩金额错误
const REASON_INVOICE_INFO_ERR = 4; // 发票信息不全/错误
const REASON_EXPRESS_INFO_ERR = 5; // 快递信息不全/错误
const REASON_PRODUCT_OPEN_ERR = 6; // 产品开通错误

const REASON_CONTRACT_MISSING_PAGE = 7; // 合同缺页
const REASON_CONTRACT_FUZZY = 8; // 合同模糊
const REASON_SEAL_FUZZY = 9; // 盖章模糊
const REASON_SEAL_ERR = 10; // 盖章错误
const REASON_SIGN_FUZZY = 11; // 签字模糊
const REASON_CONTRACT_NO_ERR = 12; // 合同编号错误
const REASON_NOT_SEAL = 13; // 未盖章

const REASON_SYSTEM_AUTO = 20; // 系统自动审批

const REASON_OTHER = 0; // 其他

export default {
    ADD_PAY,
    UPDATE_PAY,
    EMPTY_PAY,
    DELETE_PAY,
    FILL_INVOICE,
    TYPE_CREATE,
    TYPE_CLOSE,
    TYPE_REVISE,
    TYPE_FILL,
    TYPE_CHECKED_INIT,
    REVISE_NOTICE,
    PRODUCT_LINE,
    FINANCE_LINE,
    CONTRACT_LINE,
    TYPE_APPLY,
    TYPE_NO_CHECKED,
    TYPE_CHECKED,
    TYPE_CHECKED_FAIL,
    TYPE_CHECKED_UPLOAD,
    NEED_RETURN,
    NOT_NEED_RETURN,
    TYPE_TRY_OUT,
    TYPE_RENEW_BEFORE,
    TYPE_RENEW_TIMELY,
    TYPE_RENEW_AFTER,
    TYPE_FORMAL,
    TYPE_RENEW,
    TYPE_FORMAL_AND_RENEW,
    ZUJUAN_PRODUCT_CODE,
    PAIKE_PRODUCT_CODE,
    PAPER_INSPERCTION_PRODUCT_CODE,
    XWT_PRODUCT_CODE,
    XWT_POINT_PRODUCT_CODE,
    WORK_PRODUCT_CODE,
    XB_PRODUCT_CODE,
    XB3_PRODUCT_CODE,
    ZUJUANCOR_PRODUCT_CODE,
    BEIKE_PRODUCT_CODE,
    DIGITIZEDCAMPUS_PRODUCT_CODE,
    PAIKE_NEW_PRODUCT_CODE,
    DIVISION_PRODUCT_CODE,
    XWT_COIN_PRODUCT_CODE,
    OFFICIAL_WEBSITE_PRODUCT_CODE,
    MICRO_CLASS_CODE,
    VR_PRODUCT_CODE,
    getRegexp() {
        return Regexp;
    },
    getNoNeedSetProduct() {
        return [BEIKE_PRODUCT_CODE, PAIKE_PRODUCT_CODE, PAPER_INSPERCTION_PRODUCT_CODE];
    },

    getSubjects() {
        return [
            {subject_id: 2, subject_name: '语文'},
            {subject_id: 3, subject_name: '数学'},
            {subject_id: 4, subject_name: '英语'},
            {subject_id: 5, subject_name: '科学'},
            {subject_id: 20, subject_name: '历史与社会(人文地理)'},
            {subject_id: 6, subject_name: '物理'},
            {subject_id: 7, subject_name: '化学'},
            {subject_id: 8, subject_name: '历史'},
            {subject_id: 9, subject_name: '道德与法治'},
            {subject_id: 1015, subject_name: '思想政治'},
            {subject_id: 21, subject_name: '社会法治'},
            {subject_id: 10, subject_name: '地理'},
            {subject_id: 11, subject_name: '生物学'},
            {subject_id: 99, subject_name: '跨科'},
            {subject_id: 19, subject_name: '基本能力'},
            {subject_id: 16, subject_name: '劳动'},
            {subject_id: 15, subject_name: '通用技术'},
            {subject_id: 14, subject_name: '信息技术'},
            {subject_id: 12, subject_name: '综合'},
            {subject_id: 18, subject_name: '专题教育'},
            {subject_id: 1006, subject_name: '音乐'},
            {subject_id: 1008, subject_name: '美术'},
            {subject_id: 1010, subject_name: '体育与健康'},
            {subject_id: 1012, subject_name: '心理健康'},
            {subject_id: 1016, subject_name: '中职专业课'},
            {subject_id: 1013, subject_name: '职业技能大赛'},
            {subject_id: 1017, subject_name: '班会'},
            {subject_id: 1019, subject_name: '地方、校本课程'},
            {subject_id: 1021, subject_name: '综合实践活动'},
        ];
    },
    getSubjects2() {
        return [
            {subject_id: 0, subject_name: '批量设置'},
            {subject_id: 2, subject_name: '语文'},
            {subject_id: 3, subject_name: '数学'},
            {subject_id: 4, subject_name: '英语'},
            {subject_id: 5, subject_name: '科学'},
            {subject_id: 20, subject_name: '历史社会'},
            {subject_id: 6, subject_name: '物理'},
            {subject_id: 7, subject_name: '化学'},
            {subject_id: 8, subject_name: '历史'},
            {subject_id: 9, subject_name: '道德与法治'},
            {subject_id: 1015, subject_name: '思想政治'},
            {subject_id: 18, subject_name: '专题教育'},
            {subject_id: 21, subject_name: '社会法治'},
            {subject_id: 10, subject_name: '地理'},
            {subject_id: 11, subject_name: '生物'},
            {subject_id: 99, subject_name: '跨科'},
            {subject_id: 19, subject_name: '基本能力'},
            {subject_id: 16, subject_name: '劳技'},
            {subject_id: 15, subject_name: '通用技术'},
            {subject_id: 14, subject_name: '信息技术'},
            {subject_id: 1006, subject_name: '音乐'},
            {subject_id: 1008, subject_name: '美术'},
            {subject_id: 1010, subject_name: '体育'},
            {subject_id: 12, subject_name: '综合'},
            {subject_id: 1012, subject_name: '心理健康'},
            {subject_id: 1013, subject_name: '职业技能大赛'},
            {subject_id: 1016, subject_name: '中职专业课'},
            {subject_id: 1017, subject_name: '班会'},
            {subject_id: 1019, subject_name: '地方、校本课程'},
            {subject_id: 1021, subject_name: '综合实践活动'},
        ];
    },


    getType() {
        return [
            {
                value: '',
                label: '不限'
            },
            {
                value: TYPE_APPLY,
                label: '申请'
            },
            {
                value: TYPE_TRY_OUT,
                label: '试用',
                disabled: true
            }, 
            {
                value: TYPE_FORMAL,
                label: '正式(新单)'
            }, 
            {
                value: TYPE_RENEW,
                label: '正式(续单)',
            },
            {
                value: TYPE_FORMAL_AND_RENEW,
                label: '正式'
            }
        ]
    },

    /**
     * 得到财务审批不通过原因序列
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getFinanceReasons() {
        return {
            [REASON_CONTRACT_AMOUNT_ERR]: '合同金额错误',
            [REASON_CONTRACT_TIME_ERR]: '合同时间错误',
            [REASON_RESULT_AMOUNT_ERR]: '业绩金额错误',
            [REASON_INVOICE_INFO_ERR]: '发票信息不全/错误',
            [REASON_EXPRESS_INFO_ERR]: '快递信息不全/错误',
            [REASON_PRODUCT_OPEN_ERR]: '产品开通错误',
            [REASON_SYSTEM_AUTO]: '系统自动审批'
        };
    },

    /**
     * 得到合同审批不通过原因序列
     * @returns {{[p: string]: string, [p: number]: string}}
     */
    getContractReasons() {
        return {
            [REASON_CONTRACT_MISSING_PAGE]: '合同缺页',
            [REASON_CONTRACT_FUZZY]: '合同模糊',
            [REASON_SEAL_FUZZY]: '盖章模糊',
            [REASON_SEAL_ERR]: '盖章错误',
            [REASON_SIGN_FUZZY]: '签字模糊',
            [REASON_CONTRACT_NO_ERR]: '合同编号错误',
            [REASON_NOT_SEAL]: '未盖章',
            [REASON_SYSTEM_AUTO]: '系统自动审批'
        };
    },

    getReasons(type) {
        let reasons = {};
        if (type == 2) {
            reasons = this.getFinanceReasons();
        }

        if (type == 3) {
            reasons = this.getContractReasons();
        }

        return reasons;
    },

    getStages() {
        return [
            {value: 0, label: '全部'},
            {value: 1, label: '小学'},
            {value: 2, label: '初中'},
            {value: 3, label: '高中'},
            {value: 4, label: '中职'},
        ];
    },

    //设置申请时间：本周，本月，上周，上月
    getDataTimes(timeRange) {
        const currentDate = new Date();
        let startDate, endDate;
        switch (timeRange) {
          // ... 其他case
          case "this_year":
            startDate = new Date(currentDate.getFullYear(), 0, 1); // 年初
            endDate = new Date(currentDate.getFullYear(), 11, 31); // 年末
            endDate.setHours(23, 59, 59, 999); // 设置为年末的最后一刻
            break;
          case "this_week":
            startDate = new Date(currentDate);
            startDate.setDate(
              currentDate.getDate() -
                currentDate.getDay() +
                (currentDate.getDay() === 0 ? -6 : 1)
            );
            endDate = new Date(startDate.getTime() + 6 * 86400000);
            break;
          case "last_week":
            startDate = new Date(currentDate);
            startDate.setDate(currentDate.getDate() - currentDate.getDay() - 6);
            endDate = new Date(startDate.getTime() + 6 * 86400000);
            break;
          case "this_month":
            startDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              2
            );
            endDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth() + 1,
              0,
              23,
              59,
              59,
              999
            );
            break;
          case "last_month":
            startDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth() - 1,
              2
            );
            endDate = new Date(
              currentDate.getFullYear(),
              currentDate.getMonth(),
              0,
              23,
              59,
              59,
              999
            );
            break;
          case "to_day":
            startDate = new Date(currentDate);
            endDate = new Date(currentDate);
            break;
        }
        return [
          this.formatDate(startDate),
          this.formatDate(endDate),
        ];
    },
  
    formatDate(date) {
        return date.toISOString().split("T")[0];
    },

    timestampToDateTime(timestamp) {
        const date = new Date(timestamp * 1000);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    leadStatuses(){
        return [
          {
            value: '',
            label: '全部'
          },
          {
            value: 1,
            label: '信息属实',
            // children: [
            //   {
            //     value: 7,
            //     label: '意向客户'
            //   },
            //   {
            //     value: 8,
            //     label: '正式合作用户'
            //   }
            // ]
          },
          {
            value: 2,
            label: '信息不属实',
            children: [
              {
                value: 1,
                label: '学生或家长、非学校职工'
              },
              {
                value: 2,
                label: '空号、手机号码无效'
              },
              {
                value: 3,
                label: '关机、无法接通或多次挂断'
              },
              {
                value: 4,
                label: '不是申请人或负责人'
              },
              {
                value: 5,
                label: '竞品公司'
              },
              {
                value: 6,
                label: '学校名称，申请人信息不正确'
              },
              {
                value: 0,
                label: '其他'
              }
            ]
          },
          {
            value: 3,
            label: '未核实'
          },
          {
            value: 0,
            label: '无'
          }
      ];
    },

    orderCheckStatus(){
      return [
        {
            value: '',
            label: '不限'
        },
        {
            value: TYPE_NO_CHECKED,
            label: '待审核'
        }, 
        {
            value: TYPE_CHECKED,
            label: '通过'
        }, 
        {
            value: TYPE_CHECKED_FAIL,
            label: '未通过'
        }, 
        {
            value: TYPE_CHECKED_UPLOAD,
            label: '未上传'
        }
      ];
    }
}



// WEBPACK FOOTER //
// ./src/config/params.js